import React, { useEffect, useState } from 'react';
import { useAppSelector } from '../../../hooks/store-hook';
import TopBarMobile from './TopBarMobile';
import { useDispatch } from 'react-redux';
import { navBarActions } from '../../../store/navBarSlice';

export interface TopBarProps {
  currentRouteName?: string;
}

const TopBar = (props: TopBarProps) => {
  const topBarVisibility = useAppSelector((state) => state.topBar);
  const dispatch = useDispatch();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (props.currentRouteName) {
      dispatch(navBarActions.setCurrentPath(props.currentRouteName));
    }
  }, [props.currentRouteName]);

  useEffect(() => {
    setVisible(topBarVisibility.visible);
  }, [topBarVisibility.visible]);

  return visible ? <TopBarMobile /> : null;
};

export default TopBar;
